import { USERS_ROUTES } from '../constants/routePaths'
import { formatRoute } from 'react-router-named-routes'
import usersTypes from '../constants/usersTypes'
import { axios } from '../services'

import { try_force_logoff } from './authActions'

const reset_user_errors = () => {
  return {
    type: usersTypes.reset_errors
  }
}

// INDEX
const users_index_request = () => {
  return {
    type: usersTypes.index.request
  }
}

const users_index_success = (response) => {
  return {
    type: usersTypes.index.success,
    payload: response.data
  }
}

const users_index_failure = (messages) => {
  return {
    type: usersTypes.index.failure,
    payload: messages
  }
}

const users_index = (page=1, filters={}) => {
  return function (dispatch) {
    // Before Request
    dispatch(users_index_request())

    // Request
    axios.get(
      USERS_ROUTES.index,
      {
        params: {
          page: page,
          per_page: 10,
          filters: filters
        }
      }
    ).then( response => {
      // success
      dispatch( users_index_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching users."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( users_index_failure(errors))
    })
  }

}

// LOCK = DISABLE
const lock_user_request = () => {
  return {
    type: usersTypes.lock.request
  }
}

const lock_user_success = (response) => {
  return {
    type: usersTypes.lock.success,
    payload: response.data
  }
}

const lock_user_failure = (messages) => {
  return {
    type: usersTypes.lock.failure,
    payload: messages
  }
}

const lock_user = (user_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(lock_user_request())

    // Request
    axios.post(
      formatRoute(USERS_ROUTES.lock, {id: user_id})
    ).then( response => {
      // success
      dispatch( lock_user_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error locking user."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( lock_user_failure(errors))
    })
  }
}

// UNLOCK + ENABLE
const unlock_user = (user_id) => {
  return function (dispatch) {
    // Before Request
    dispatch(lock_user_request())

    // Request
    axios.post(
      formatRoute(USERS_ROUTES.unlock, {id: user_id})
    ).then( response => {
      // success
      dispatch( lock_user_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error unlocking user."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( lock_user_failure(errors))
    })
  }
}

// DELETE
const destroy_user_request = () => {
  return {
    type: usersTypes.destroy.request
  }
}

const destroy_user_success = (response) => {
  return {
    type: usersTypes.destroy.success,
    payload: response.data
  }
}

const destroy_user_failure = (messages) => {
  return {
    type: usersTypes.destroy.failure,
    payload: messages
  }
}

const destroy_user = (user_id, page=1, per_page=10) => {
  return function (dispatch) {
    // Before Request
    dispatch(destroy_user_request())

    // Request
    axios.delete(
      formatRoute(USERS_ROUTES.destroy, {id: user_id}),
      {
        page: page,
        per_page: per_page
      }
    ).then( response => {
      // success
      dispatch( destroy_user_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error deleting user."]
      }
      dispatch( try_force_logoff(error.response.data) )
      dispatch( destroy_user_failure(errors))
    })
  }
}

// UPDATE
const update_user_request = () => {
  return {
    type: usersTypes.update.request
  }
}

const update_user_success = (response) => {
  return {
    type: usersTypes.update.success,
    payload: response.data
  }
}

const update_user_failure = (messages) => {
  return {
    type: usersTypes.update.failure,
    payload: messages
  }
}

const update_user = (user_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(update_user_request())

    // Request
    axios.patch(
      formatRoute(USERS_ROUTES.update, {id: user_id}),
      values
    ).then( response => {
      // success
      dispatch( update_user_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating user."]
      }
      dispatch( try_force_logoff(error.response) )
      dispatch( update_user_failure(errors))
    })
  }

}

// change password
const change_password_request = () => {
  return {
    type: usersTypes.change_password.request
  }
}

const change_password_success = (response) => {
  return {
    type: usersTypes.change_password.success,
    payload: response.data
  }
}

const change_password_failure = (messages) => {
  return {
    type: usersTypes.change_password.failure,
    payload: messages
  }
}

const change_password = (user_id, values) => {
  return function (dispatch) {
    // Before Request
    dispatch(change_password_request())

    // Request
    axios.post(
      formatRoute(USERS_ROUTES.change_password, {id: user_id}),
      values
    ).then( response => {
      // success
      dispatch( change_password_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error updating password."]
      }
      dispatch( try_force_logoff(error.response) )
      dispatch( change_password_failure(errors))
    })
  }

}

// CREATE
const create_user_init = () => {
  return {
    type: usersTypes.create.init
  }
}

const create_user_request = () => {
  return {
    type: usersTypes.create.request
  }
}

const create_user_success = (response) => {
  return {
    type: usersTypes.create.success,
    payload: response.data
  }
}

const create_user_failure = (messages) => {
  return {
    type: usersTypes.create.failure,
    payload: messages
  }
}

const create_user = (values) => {
  return function (dispatch) {
    // Before Request
    dispatch(create_user_request())

    // Request
    axios.post(
      USERS_ROUTES.create,
      values
    ).then( response => {
      // success
      dispatch( create_user_success(response) )
    }).catch( error=> {
      // failure
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error creating user."]
      }
      dispatch( try_force_logoff(error.response) )
      dispatch( create_user_failure(errors))
    })
  }

}


export {
  reset_user_errors,
  users_index,
  lock_user,
  unlock_user,
  destroy_user,
  update_user,
  change_password,
  create_user_init,
  create_user
}



// WEBPACK FOOTER //
// ./src/js/actions/usersActions.js